import type { Group, GroupMemberCount, GroupMemberCounts, YammerState } from '../../state/types';
import { createFindRecordById, createFindRecordByIdThrows } from '../findRecordById';

const findByIdThrows = createFindRecordByIdThrows<GroupMemberCount>('groupMemberCounts');
const findById = createFindRecordById<GroupMemberCount>('groupMemberCounts');

type GetTotalMemberCountByIdThrows = (state: YammerState, groupId: Group['id']) => GroupMemberCount['totalMemberCount'];

export const getTotalMemberCountByIdThrows: GetTotalMemberCountByIdThrows = (state, groupId) =>
  findByIdThrows(state, groupId).totalMemberCount;

type GetTotalMemberCountById = (state: YammerState, groupId: Group['id']) => GroupMemberCount['totalMemberCount'];
export const getTotalMemberCountById: GetTotalMemberCountById = (state, groupId) =>
  findById(state, groupId)?.totalMemberCount ?? 0;

type GetFulfilledGroupMemberCounts = (state: YammerState) => GroupMemberCounts;
/**
 * @deprecated PERFORMANCE This returns the entire reducer state, it will return a new object instance every time ANY
 * group gets its member count updated and will force all consumers to re-render. This should be deleted.
 */
export const getFulfilledGroupMemberCounts: GetFulfilledGroupMemberCounts = (state) => state.groupMemberCounts;
